export default {
      ProductColors: 'ProductColor|ProductColors',
      ProductColors_no_body: 'ProductColor',

};
